import { Convention } from '../../../concepts/objects';
import { Physical } from '../../canvas/entities/Physical';

export interface Assignable extends Physical {
    taskId?: string;
}

export const Assignable = new Convention<Assignable>('Assignable');
